import angular from 'angular';
import {
  pmDataService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-document-attachment-dialog.controller';
import template from './edit-document-attachment-dialog.html';
import documentAttachmentNameMessagesTpl from './messages/document-attachment.name.messages.html';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

class dialogService {
  getOptions($event, {
    document,
    attachment,
    attachmentType,
  }) {
    return {
      controller,
      controllerAs: 'editDocumentAttachmentDialogVM',
      locals: {
        document,
        attachment,
        attachmentType,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.editDocumentAttachmentDialog', [
  alerts,
  pmDataService,
  ngFileUpload,
  ssDialogService,
])
  .service('editDocumentAttachmentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('document-attachment.name.messages.html', documentAttachmentNameMessagesTpl);
  })
  .name;
